"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testBgColor = testBgColor;
exports.resolveImgSrc = resolveImgSrc;
exports.viewsDisplay = viewsDisplay;
exports.engagementDisplay = engagementDisplay;

var _widgets = require("./widgets.constants");

var _styledComponents = require("styled-components");

var _prettyMs = _interopRequireDefault(require("pretty-ms"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function testBgColor() {
  var imgSrc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /^#/.test(imgSrc);
}

function resolveImgSrc() {
  var imgSrc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var srcOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isBgColor = testBgColor(imgSrc);

  if (!isBgColor && srcOnly) {
    return imgSrc || _widgets.defaultQuestionImgSrc;
  }

  return isBgColor && imgSrc || (0, _styledComponents.css)(["url(", ")"], imgSrc || _widgets.defaultQuestionImgSrc);
}

function viewsDisplay(views) {
  if (!views || views < 1000) {
    return views || 0;
  }

  if (views < 999999) {
    var thousands = views / 1000;

    var _decimalPlaces = views < 10000 ? 1 : 0;

    return "".concat(thousands.toFixed(_decimalPlaces), "k");
  }

  var millions = views / 1000000;
  var decimalPlaces = views < 100000000 ? 1 : 0;
  return "".concat(millions.toFixed(decimalPlaces), "m");
}

var dayInMilliseconds = 1000 * 60 * 60 * 24;

function engagementDisplay(engagement) {
  if (engagement >= dayInMilliseconds) {
    return "".concat((0, _prettyMs["default"])(engagement, {
      compact: true
    }), "+");
  }

  return (0, _prettyMs["default"])(engagement, {
    unitCount: 2
  });
}